import { render, staticRenderFns } from "./TrueLabelChart.vue?vue&type=template&id=ff0761c6&scoped=true&"
import script from "./TrueLabelChart.vue?vue&type=script&lang=js&"
export * from "./TrueLabelChart.vue?vue&type=script&lang=js&"
import style0 from "./TrueLabelChart.vue?vue&type=style&index=0&id=ff0761c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0761c6",
  null
  
)

export default component.exports